var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g2, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 26,
    viewBox: "0 0 41 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5786 17.2875L29.2807 15.7026C29.2807 15.7026 29.8 16.1353 29.8732 16.3565C29.9463 16.5777 28.9614 17.1271 28.5786 17.2875Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5799 0.658581C25.5799 0.658581 30.3364 -0.0463367 34.1079 3.68C34.4492 4.01788 34.5589 4.52591 34.381 4.97316L29.8707 16.3588C29.8707 16.3588 27.206 12.5863 20.4504 12.8075L25.5799 0.658581Z",
    fill: "url(#paint0_linear_23_924)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8736 16.3588C29.8736 16.3588 30.054 16.5314 28.7302 17.1707C27.4064 17.81 32.4359 21.6214 34.8276 21.2908L40.5007 10.2868C40.5007 10.2868 36.1831 9.31451 33.7597 6.54346L29.8712 16.3613L29.8736 16.3588Z",
    fill: "url(#paint1_linear_23_924)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0538 4.27579C24.0538 4.27579 26.8282 4.28308 29.3588 5.50818L30.7558 1.44639C30.7558 1.44639 28.3568 0.342832 25.5922 0.646676L24.0538 4.27579Z",
    fill: "#3F3F3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.359 5.5083L27.6743 9.48987C27.6743 9.48987 30.5901 10.4719 31.6701 11.821L33.1695 8.03385C33.1695 8.03385 32.0578 6.40768 29.3565 5.5083H29.359Z",
    fill: "#3F3F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2985 8.43736C22.2985 8.43736 25.3582 8.11164 27.6743 9.48988L25.9384 13.644C25.9384 13.644 23.7979 12.696 20.453 12.8054L22.2961 8.43493L22.2985 8.43736Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23_924",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 6,
    width: 13,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8735 16.3588C29.8735 16.3588 30.0539 16.5314 28.7301 17.1707C27.4063 17.81 32.4358 21.6214 34.8274 21.2908L40.5006 10.2868C40.5006 10.2868 36.183 9.31451 33.7596 6.54346L29.8711 16.3613L29.8735 16.3588Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9236 10.2868L34.7029 12.2168L36.4094 8.64361C36.4094 8.64361 34.3177 7.1803 33.8057 6.4292L31.9236 10.2892V10.2868Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7028 12.2144L32.984 15.8046C32.984 15.8046 35.4073 17.2776 36.9262 17.2193L38.8473 13.4929C38.8473 13.4929 36.6751 13.4565 34.7028 12.2144Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0147 14.3193L32.9841 15.8045L31.1703 20.107C31.1703 20.107 28.4666 18.8454 28.3983 16.9761L30.0147 14.3193Z",
    fill: "#3F3F3F"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.8735 16.3588C29.8735 16.3588 30.0539 16.5314 28.7301 17.1707C27.4063 17.81 32.4358 21.6214 34.8274 21.2908L40.5006 10.2868C40.5006 10.2868 36.183 9.31451 33.7596 6.54346L29.8711 16.3613L29.8735 16.3588Z",
    fill: "url(#paint2_linear_23_924)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5919 0.646783C25.5919 0.646783 25.2237 0.0658335 24.7191 0.284601L14.5064 24.281C14.4772 24.349 14.4625 24.4244 14.465 24.4997C14.4699 24.6893 14.5235 25.0248 14.8502 25.088C15.0891 25.1342 15.3231 24.9932 15.4182 24.7696L25.5919 0.646783Z",
    fill: "url(#paint3_linear_23_924)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.424 17.2875L11.7219 15.7026C11.7219 15.7026 11.2026 16.1353 11.1295 16.3565C11.0563 16.5777 12.0413 17.1271 12.424 17.2875Z",
    fill: "#939393"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4227 0.658581C15.4227 0.658581 10.6662 -0.0463367 6.89228 3.68C6.55096 4.01788 6.44126 4.52591 6.61923 4.97316L11.1295 16.3588C11.1295 16.3588 13.7942 12.5863 20.5498 12.8075L15.4227 0.658581Z",
    fill: "url(#paint4_linear_23_924)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1295 16.3588C11.1295 16.3588 10.9491 16.5314 12.2729 17.1707C13.5967 17.81 8.56723 21.6214 6.17558 21.2908L0.5 10.2844C0.5 10.2844 4.81764 9.31207 7.24097 6.54102L11.1295 16.3588Z",
    fill: "url(#paint5_linear_23_924)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9487 4.27579C16.9487 4.27579 14.1743 4.28308 11.6437 5.50818L10.2467 1.44639C10.2467 1.44639 12.6457 0.342832 15.4103 0.646676L16.9487 4.27579Z",
    fill: "#3F3F3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.644 5.5083L13.3287 9.48987C13.3287 9.48987 10.4129 10.4719 9.33284 11.821L7.8335 8.03385C7.8335 8.03385 8.94521 6.40768 11.6465 5.5083H11.644Z",
    fill: "#3F3F3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7041 8.43736C18.7041 8.43736 15.6444 8.11164 13.3284 9.48988L15.0642 13.644C15.0642 13.644 17.2047 12.696 20.5496 12.8054L18.7065 8.43493L18.7041 8.43736Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_23_924",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 13,
    height: 16
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1295 16.3588C11.1295 16.3588 10.9491 16.5314 12.2729 17.1707C13.5967 17.81 8.56723 21.6214 6.17558 21.2908L0.5 10.2844C0.5 10.2844 4.81764 9.31207 7.24097 6.54102L11.1295 16.3588Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_23_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07655 10.2868L6.29727 12.2168L4.5907 8.64361C4.5907 8.64361 6.68247 7.1803 7.19444 6.4292L9.07655 10.2892V10.2868Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30006 12.2144L8.01882 15.8046C8.01882 15.8046 5.59549 17.2776 4.07663 17.2193L2.15552 13.4929C2.15552 13.4929 4.32774 13.4565 6.30006 12.2144Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9885 14.3193L8.01904 15.8045L9.83289 20.107C9.83289 20.107 12.5366 18.8454 12.6049 16.9761L10.9885 14.3193Z",
    fill: "#3F3F3F"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M11.1295 16.3588C11.1295 16.3588 10.9491 16.5314 12.2729 17.1707C13.5967 17.81 8.56723 21.6214 6.17558 21.2908L0.5 10.2844C0.5 10.2844 4.81764 9.31207 7.24097 6.54102L11.1295 16.3588Z",
    fill: "url(#paint6_linear_23_924)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4108 0.646783C15.4108 0.646783 15.7789 0.0658335 16.2836 0.284601L26.4962 24.281C26.5255 24.349 26.5401 24.4244 26.5376 24.4997C26.5328 24.6893 26.4791 25.0248 26.1524 25.088C25.9135 25.1342 25.6795 24.9932 25.5844 24.7696L15.4108 0.646783Z",
    fill: "url(#paint7_linear_23_924)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_924",
    x1: 31.7327,
    y1: 2.5895,
    x2: 24.4557,
    y2: 13.4097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_924",
    x1: 37.6311,
    y1: 8.98776,
    x2: 31.3012,
    y2: 18.3971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_924",
    x1: 35.8038,
    y1: 15.046,
    x2: 30.8758,
    y2: 12.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23_924",
    x1: 20.6308,
    y1: 13.0046,
    x2: 18.7264,
    y2: 12.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23_924",
    x1: 9.27427,
    y1: 2.57751,
    x2: 16.5513,
    y2: 13.3977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23_924",
    x1: 3.37814,
    y1: 8.97744,
    x2: 9.70462,
    y2: 18.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23_924",
    x1: 5.20357,
    y1: 15.034,
    x2: 10.1299,
    y2: 12.4883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_23_924",
    x1: 20.3745,
    y1: 12.9944,
    x2: 22.2789,
    y2: 12.0104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacing);
export default __webpack_public_path__ + "static/media/racing.5dcdfef0eeb3f167f94e5acaed2d5c12.svg";
export { ForwardRef as ReactComponent };